document.addEventListener("DOMContentLoaded", async function () {
    // Reset the reloading flag on page load
    let bundleComponentVariantIds = [];
    let isBundle = false;
    if (typeof window.Shopify !== "undefined" && window.Shopify.routes) {
function toBoolean(val) {
    if (val === true) return true;
    if (val === false) return false;
    if (typeof val === "string") {
        return val.trim().toLowerCase() === "true";
    }
    return false;
}
 

    let metafieldSettings = {};
    window.isReloadingForFilter = false;
    try {
        // Read from script tag with type="application/json" (safer for JSON data)
        const rajsScript = document.getElementById('multiloca-settings');
        if (rajsScript && rajsScript.textContent) {
            const metafieldValue = rajsScript.textContent.trim();
            if (metafieldValue) {
                const metafieldData = JSON.parse(metafieldValue);
                metafieldSettings = { ...metafieldData };
                delete metafieldSettings.locations_arr;
            }
        } 
    } catch (error) {
        console.error('Error parsing metafield data:', error);
        console.error('Error details:', error.message);
    }
    
        const shopdomain = Shopify.shop || window.location.hostname;
        const locale = window.Shopify.locale;
        const market = document.getElementById('market-id').value;
        let callapi = false;
        const customerEnterPincode = localStorage.getItem("selected_location_pincode") || null;
        const customerEnterAddress = localStorage.getItem("selected_location_text") || null;
        const multilocaCustomKey = localStorage.getItem("multiloca_custom_key") || null;

        function getInventoryData1(key) {
            const cookies = document.cookie.split("; ");
            var settings = null;
            var cookieData = null
            for (let cookie of cookies) {
                const [ckey, value] = cookie.split("=");
                if (ckey === key) {
                    try {
                        settings = JSON.parse(decodeURIComponent(value));
                        // Check if metafieldSettings exists and is valid (not empty object)
                        if (metafieldSettings != undefined && metafieldSettings != null && metafieldSettings != '' && 
                            typeof metafieldSettings === 'object' && !Array.isArray(metafieldSettings) && Object.keys(metafieldSettings).length > 0) {
                            // Check if location_arr exists in cookie
                            const location_arr_cookie = cookies.find(cookie => cookie.includes("location_arr"));
                            const headerBlock_cookie = cookies.find(cookie => cookie.includes("haderBlock"));
                            if (location_arr_cookie) {
                                try {
                                    const location_arr_value = location_arr_cookie.split("=").slice(1).join("="); // Handle values with = in them
                                    const headerBlock_value = headerBlock_cookie.split("=").slice(1).join("="); // Handle values with = in them
                                    const location_arr = JSON.parse(decodeURIComponent(location_arr_value));
                                    
                                    // Safely parse locationPopupDescription
                                    let locationPopupDescription = metafieldSettings?.locationPopupDescription;
                                    if (typeof locationPopupDescription === 'string' && locationPopupDescription.trim()) {
                                        try {
                                            locationPopupDescription = JSON.parse(locationPopupDescription);
                                        } catch (e) {
                                            locationPopupDescription = { defaultval: 'Shop from Location' };
                                        }
                                    } else if (locationPopupDescription && typeof locationPopupDescription === 'object') {
                                        // Check if defaultval is empty and set default
                                        const defaultval = locationPopupDescription.defaultval;
                                        if (!defaultval || (typeof defaultval === 'string' && defaultval.trim() === '')) {
                                            locationPopupDescription = { defaultval: 'Shop from Location' };
                                        }
                                    } else {
                                        locationPopupDescription = { defaultval: 'Shop from Location' };
                                    }
                                    
                                    // Safely parse locationPopupHeader
                                    let locationPopupHeader = metafieldSettings?.locationPopupHeader;
                                    if (typeof locationPopupHeader === 'string' && locationPopupHeader.trim()) {
                                        try {
                                            locationPopupHeader = JSON.parse(locationPopupHeader);
                                        } catch (e) {
                                            locationPopupHeader = { defaultval: 'Shop from Location' };
                                        }
                                    } else if (locationPopupHeader && typeof locationPopupHeader === 'object') {
                                        // Already an object, use it as-is
                                        locationPopupHeader = locationPopupHeader;
                                    } else {
                                        locationPopupHeader = { defaultval: 'Shop from Location' };
                                    }
                                    
                                    // Safely parse showSettingsHeader
                                    let showSettingsHeader = metafieldSettings?.showSettingsHeader;
                                    if (typeof showSettingsHeader === 'string' && showSettingsHeader.trim()) {
                                        try {
                                            showSettingsHeader = JSON.parse(showSettingsHeader);
                                        } catch (e) {
                                            showSettingsHeader = { address: false, phone: true, notes: true, directions: true, googleRatingTimeing: true };
                                        }
                                    } else if (!showSettingsHeader || typeof showSettingsHeader !== 'object') {
                                        showSettingsHeader = { address: true, phone: true, notes: true, directions: false, googleRatingTimeing: true };
                                    }
                                    
                                    cookieData = {
                                        locations_arr : location_arr,
                                        locationFilterSetting : {
                                            enableGeolocationSearch:metafieldSettings?.enableGeolocationSearch,
                                            // googleMapsAPIKey:metafieldSettings?.googleMapsAPIKey,
                                            locationRadius:metafieldSettings?.locationRadius,
                                            locationRadiusValues:metafieldSettings?.locationRadiusValues
                                        },
                                        locationDetection:metafieldSettings?.locationDetection,
                                        addressPrepopulation:metafieldSettings?.addressPrepopulation,
                                        headerBlockstyle :metafieldSettings?.headerBlockstyle,
                                        headerBlock :headerBlock_value ? `${headerBlock_value}` : "",
                                        showSettingsHeader : JSON.stringify(showSettingsHeader) ?? '[]',
                                        headerSettingsPriority :metafieldSettings?.headerSettingsPriority,
                                        hideOutofStockItems :metafieldSettings?.hideOutofStockItems,
                                        purchaseFromOneLocation :metafieldSettings?.purchaseFromOneLocation,
                                        pushDownOutofStockItems :metafieldSettings?.pushDownOutofStockItems,
                                        enabledOtherLocationMessage : toBoolean(metafieldSettings?.enabledOtherLocationMessage),
                                        locationPopup :metafieldSettings?.locationPopup,
                                        locationPopupstyle :metafieldSettings?.locationPopupstyle,
                                        headerBlockIcon :`${metafieldSettings?.headerBlockIcon}`,
                                        locationPopupHeader : locationPopupHeader?.defaultval ?locationPopupHeader?.defaultval :'Shop from Location',
                                        locationPopupDescription : locationPopupDescription?.defaultval ?locationPopupDescription?.defaultval : 'Shop from Location',
                                        quantityBasedOnLocation :metafieldSettings?.quantityBasedOnLocation || "false",
                                        otherLocationMessage : (() => {
                                            const msg = metafieldSettings?.otherLocationMessage;
                                            if (typeof msg === 'string' && msg.trim()) {
                                                try {
                                                    const parsed = JSON.parse(msg);
                                                    return parsed?.defaultval || msg;
                                                } catch (e) {
                                                    return msg;
                                                }
                                            }
                                            return msg || "✔ Available in other locations";
                                        })(),
                                        notAvailableMessage : (() => {
                                            const msg = metafieldSettings?.notAvailableMessage;
                                            if (typeof msg === 'string' && msg.trim()) {
                                                try {
                                                    const parsed = JSON.parse(msg);
                                                    return parsed?.defaultval || msg;
                                                } catch (e) {
                                                    return msg;
                                                }
                                            }
                                            return msg || "Out of Stock";
                                        })(),
                                        availableMessage : (() => {
                                            const msg = metafieldSettings?.availableMessage;
                                            if (typeof msg === 'string' && msg.trim()) {
                                                try {
                                                    const parsed = JSON.parse(msg);
                                                    return parsed?.defaultval || msg;
                                                } catch (e) {
                                                    return msg;
                                                }
                                            }
                                            return msg || "✔ Available";
                                        })(),
                                    }
                                    return cookieData;
                                } catch (parseError) {
                                    console.error('Error parsing location_arr from cookie:', parseError);
                                    return null;
                                }
                            } else {
                                // location_arr not found in cookie
                                return null;
                            }
                        } else {
                            // metafieldSettings is not valid
                            return null;
                        }
                    
                    } catch (e) {
                        console.error('Error parsing JSON from cookie:', e);
                        console.error('Invalid JSON:', value); // Log the problematic JSON
                        return null; // Return null or handle the error gracefully
                    }
                }
            }
            return null; // Return null if cookie not found
        }

        var enabledSmartCollectionFilter = false;
        // Global variables for inventory status messages        
        let noDataMessage = 'No data for selected variant';
        let otherLocationMessage = '✔ Available in other locations';
        let notAvailableMessage = 'Out of Stock';
        let availableMessage = '✔ Available';
        let enabledOtherLocationMessage = false;
        let purchaseOneLocationToast = 'Items you are purchasing are availabe at the location you are choosing. Are you sure you want to switch location.';
        let someProductAvailableMessage = 'The following items in your cart are not available at Selected location. You can remove unavailable items from your cart and continue...';
        let purchaseFromOneLocation = 'false';
        let hideOutofStockItems = 'false';
        let pushDownOutofStockItems = 'false';
        let locationSelectionType = '';
        let addressPrepopulation = 'false';
        let PickeasyIntegration = 'false';
        let enabledFullfillment = 'false';
        let addToCartSelector = '';
        let quantityBasedOnLocationoutside = 'false';
        let disablebtnOutofStockItems = 'false';
        let enabledInventoryApi = 'false';
        let collectionPageProductSelector = '';
        var inventoryDataCache = null;
        var inventoryDataPromise = null;


        function setInventoryData1(key, value) {
            const locations_arr = value.settings.locations_arr || [];
            const setLocation = localStorage.getItem("selected_location");
            const headerBlockstyle = value.settings.headerBlockstyle || '';
            const headerBlock = value.settings.headerBlock || '';
            const showSettingsHeader = value.settings.showSettingsHeader || '[]';
            const headerSettingsPriority = value.settings.headerSettingsPriority || [];
            const hideOutofStockItems = value.settings.hideOutofStockItems || 'false';
            const pushDownOutofStockItems = value.settings.pushDownOutofStockItems || 'false';
            const enableGeolocationSearch = value.settings?.locationFilterSetting?.enableGeolocationSearch ?? 'false';
            const locationDetection = value.settings?.locationDetection ?? 'false';
            const purchaseFromOneLocation = value.settings?.purchaseFromOneLocation ?? 'false';
            const locationPopup = value.settings?.locationPopup ?? 'false';
            const locationPopupstyle = value.settings?.locationPopupstyle ?? 'false';
            const locationPopupHeader = value.settings?.locationPopupHeader;
            const locationPopupDescription = value.settings?.locationPopupDescription;
            const quantityBasedOnLocation = value.settings?.quantityBasedOnLocation ?? 'false';
            const locationRadius = value.settings?.locationFilterSetting?.locationRadius ?? 'false';
            const locationRadiusValues = value.settings?.locationFilterSetting?.locationRadiusValues ?? '{}';
            const headerDisabled = value.settings?.headerDisabled ?? 'false';
            otherLocationMessage = value.settings?.otherLocationMessage ?? '✔ Available in other locations';
            notAvailableMessage = value.settings?.notAvailableMessage ?? 'Out of Stock';
            availableMessage = value.settings?.availableMessage ?? '✔ Available';
            purchaseOneLocationToast = value.settings?.purchaseOneLocationToast ?? 'Items you are purchasing are availabe at the location you are choosing. Are you sure you want to switch location.';
            someProductAvailableMessage = value.settings?.someProductAvailableMessage ?? 'The following items in your cart are not available at Selected location. You can remove unavailable items from your cart and continue...';
            const addressPrepopulation = value.settings?.addressPrepopulation ?? 'false';
            const cookieData = {
                locations_arr,
                selected_location: setLocation,
                headerBlockstyle,
                headerBlock,
                showSettingsHeader,
                headerSettingsPriority,
                hideOutofStockItems,
                pushDownOutofStockItems,
                locationFilterSetting : {
                    enableGeolocationSearch,
                    locationRadius,
                    locationRadiusValues
                },
                locationDetection,
                purchaseFromOneLocation,
                locationPopup,
                locationPopupstyle,
                locationPopupHeader,
                locationPopupDescription,
                quantityBasedOnLocation,
                headerDisabled,
                otherLocationMessage,
                notAvailableMessage,
                availableMessage,
                purchaseOneLocationToast,
                someProductAvailableMessage,
                addressPrepopulation
            }
            // const setdata = encodeURIComponent(JSON.stringify(cookieData));
            // const expiryDate = new Date();
            // expiryDate.setMinutes(expiryDate.getMinutes() + 60);
            // document.cookie = `${key}=${setdata}; expires=${expiryDate.toUTCString()}; path=/`;
        }

        const getloc_inventory_stock = async () => {
            try {
                var variant_id = 0;
                var fromgeoblock = true;
                var product_id = 0;
                const multilocaCustomKey = localStorage.getItem("multiloca_custom_key") || null;
                const url = `https://multiloca.info/api/get-loc-inventory-stock?shopdomain=${encodeURIComponent(shopdomain)}&variant_id=${encodeURIComponent(variant_id)}&locale=${encodeURIComponent(locale)}&fromgeoblock=${encodeURIComponent(fromgeoblock)}&product_id=${encodeURIComponent(product_id)}&market=${encodeURIComponent(market)}&customerEnterPincode=${encodeURIComponent(customerEnterPincode)}&customerEnterAddress=${encodeURIComponent(customerEnterAddress)}&multilocaCustomKey=${encodeURIComponent(multilocaCustomKey)}`;
                const result = await fetch(url, {
                    method: 'GET',
                });
                if (!result.ok) {
                    throw new Error(`HTTP error! Status: ${result.status}`);
                }
                const data = await result.json();
                // set the location_arry at the cookie data
                const location_arr = data?.settings?.locations_arr;
                if (location_arr) {
                    const expiryDate = new Date();
                    expiryDate.setMinutes(expiryDate.getMinutes() + 60);
                    document.cookie = `location_arr=${JSON.stringify(location_arr)}; expires=${expiryDate.toUTCString()}; path=/`;
                    document.cookie = `haderBlock=${data?.settings?.headerBlock}; expires=${expiryDate.toUTCString()}; path=/`;
                }
                return data;
            } catch (error) {
                console.error('Error:', error);
            }
        }

        // Add a function to observe DOM changes and detect when an element is added
        function waitForElement(selector, callback) {
            // Check if element already exists
            const element = document.querySelector(selector);
            if (element) {
                callback(element);
                return;
            }

            // If not, set up a mutation observer to watch for it
            const observer = new MutationObserver((mutations) => {
                const element = document.querySelector(selector);
                if (element) {
                    observer.disconnect();
                    callback(element);
                }
            });

            // Start observing the document with the configured parameters
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        function executeLocationChange(selectedLocationId, locationData = null) {
            // Save the selected location to LocalStorage
            localStorage.setItem("selected_location", selectedLocationId);

            // Update dropdown if it exists
            const locationNamesDropDownselect = document.getElementById("locationNamesDropDownselect");
            if (locationNamesDropDownselect) {
                locationNamesDropDownselect.value = selectedLocationId;
            }

            // Update header display
            const locationshowonheader = document.getElementById("location-popup-header-id");
            if (locationshowonheader) {
                if (locationData && locationData.node) {
                    // Location data from drawer/popup
                    locationshowonheader.textContent = locationData.node.name;
                } else {
                    // Find location name from locationarr
                    // const location = locationarr.find(loc => loc.node.id.split('/').pop() === selectedLocationId);
                    // if (location) {
                    //     locationshowonheader.textContent = location.node.name;
                    // }
                }
            }

            // Get all product pages' radio buttons that match the selected location
            const matchingRadioButtons = document.querySelectorAll(`input[name="selected_location"][value="${selectedLocationId}"]`);
            matchingRadioButtons.forEach(radio => {
                radio.checked = true;

                // Dispatch a custom click event to ensure any associated event handlers run
                const clickEvent = new Event('change', { bubbles: true });
                radio.dispatchEvent(clickEvent);

                // Apply styling if needed
                if (locationSelectionType === 'colorinversion') {
                    const locationCard = radio.closest(".location-card-listview");
                    if (locationCard) {
                        // Reset all cards
                        const allLocationCards = document.querySelectorAll(".location-card-listview");
                        allLocationCards.forEach(card => {
                            card.style.removeProperty('background-color');
                            card.style.removeProperty('color');
                        });
                        // Style the selected card
                        locationCard.style.backgroundColor = "rgb(var(--color-foreground))";
                        locationCard.style.color = "rgb(var(--color-background))";
                    }
                }
            });

            const dropdownGeoView = document.querySelector('.location-dropdown-header');
            if (dropdownGeoView) {
                const locationshowonheader = document.querySelector(".location-dropdown-header");
                const body = document.querySelector(".location-dropdown-body");

                locationshowonheader.innerHTML = "";
                const nameSpan = document.createElement("span");
                nameSpan.textContent = locationData.node.name;
                locationshowonheader.appendChild(nameSpan);
                let arrow = document.createElement("span");
                arrow.classList.add("location-dropdown-arrow");
                arrow.textContent = "▾";
                arrow.style.marginLeft = "8px";
                locationshowonheader.appendChild(arrow);
                if (body) body.hidden = true;
            }

            // Call showlocations function if it's accessible
            if (window.multiLocationShowLocations) {
                window.multiLocationShowLocations(selectedLocationId);
            }

            // Dispatch a custom event that other scripts can listen for
            const event = new CustomEvent('locationChanged', {
                detail: { locationId: selectedLocationId }
            });
            document.dispatchEvent(event);

            updateCollectionInventory({
                collectionPageProductSelector: collectionPageProductSelector,
                enabledInventoryApi: enabledInventoryApi,
                hideOutofStockItems: hideOutofStockItems,
                pushDownOutofStockItems: pushDownOutofStockItems,
                disablebtnOutofStockItems: disablebtnOutofStockItems
            });

            // Reload page to apply location filter
            // if (enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true') {
            //     setTimeout(() => {
            //         window.location.reload();
            //     }, 500);
            // }

            console.log("Location changed to:", selectedLocationId);
        }

        async function handleLocationChange(selectedLocationId, locationData = null, source = 'dropdown', purchaseFromOneLocation = 'false') {
            const previosLocationid = localStorage.getItem("selected_location");

            if (purchaseFromOneLocation == 'true') {
                if (previosLocationid && previosLocationid !== selectedLocationId) {
                    const existingCartResponse = await fetch(`/cart.js`);
                    const existingCartData = await existingCartResponse.json();
                    const existingNoteAttributes = existingCartData.attributes || {};
                    let locationNotesAttribute = existingNoteAttributes['location_notes'];

                    if (existingCartData.items.length == 0) {
                        locationNotesAttribute = '';
                    }

                    if (!locationNotesAttribute) {
                        // No existing location notes, proceed with change
                        // executeLocationChange(selectedLocationId, locationData);
                    } else {
                        const existingNotes = locationNotesAttribute;
                        const existingLocationIds = existingNotes.split(',').map(item => item.split(':')[1]);

                        if (existingCartData.items.length != 0) {
                            if (existingLocationIds.length > 0) {
                                if (!existingLocationIds.includes(selectedLocationId)) {
                                    // Revert the selection based on source
                                    if (source === 'dropdown') {
                                        const previousLocationOption = document.querySelector(`option[value="${previosLocationid}"]`);
                                        if (previousLocationOption) {
                                            previousLocationOption.selected = true;
                                        }
                                    } else if (source === 'drawer') {
                                        // Update drawer selection back to previous
                                        const allLocationCards = document.querySelectorAll(".location-card-drawer-list-view-selected");
                                        allLocationCards.forEach(card => {
                                            card.classList.remove("location-card-drawer-list-view-selected");
                                            card.classList.add("location-card-drawer-list-view");
                                        });
                                        const previousCard = document.querySelector(`[data-location-id="${previosLocationid}"]`);
                                        if (previousCard) {
                                            previousCard.classList.remove("location-card-drawer-list-view");
                                            previousCard.classList.add("location-card-drawer-list-view-selected");
                                        }
                                    }else if(source === "dropdownGeoView"){
                                        document.querySelector('.location-dropdown-header').setAttribute('data-location-name', previosLocationid);
                                    }

                                    const previousLocationRadio = document.querySelector(`input[name="selected_location"][value="${previosLocationid}"]`);
                                    if (previousLocationRadio) {
                                        previousLocationRadio.checked = true;
                                    }

                                    // Show cart clear toast
                                    console.log(purchaseOneLocationToast);
                                    console.log("Location id recivied : ",selectedLocationId);
                                    console.log(locationData);
                                    console.log(shopdomain);
                                    console.log(someProductAvailableMessage);
                                    window.multilocation.showToast(purchaseOneLocationToast, selectedLocationId, locationData, shopdomain, someProductAvailableMessage, executeLocationChange);
                                    return false;
                                }
                            }
                        }
                    }
                }
            }

            // If we reach here, proceed with the location change
            executeLocationChange(selectedLocationId, locationData);
            return true;
        }

        const display_location_stock = async (variant_id, baseUrl, changecallapi = false) => {
            let cached = getInventoryData1("location_arr");

            if (cached) {
                // Use cached data
                if (cached != undefined && cached != null && cached != '' ) {
                    callapi = false;
                    cached = { settings: cached };
                } else {
                    callapi = true;
                }
            } else {
                callapi = true;
            }
            if (changecallapi) {
                callapi = true;
            }
        
            if(callapi){
                cached = await getloc_inventory_stock();
            }
            // if (callapi) {
                // setInventoryData1("savedlocation", cached);
            // }
            // const cached = await getloc_inventory_stock();
    
            const invntorydata = cached?.settings;

            enabledFullfillment = invntorydata?.enabledFullfillment;
            addToCartSelector = invntorydata?.addToCartSelector ?? '';
            quantityBasedOnLocationoutside = invntorydata?.quantityBasedOnLocation ?? 'false';
            // Extract translation variables from API response
            const showDirectionText = invntorydata?.locationSettings?.showDirectionText ?? 'Get Directions';
            const locationPopup = invntorydata?.locationPopup;
            const locationPopupstyle = invntorydata?.locationPopupstyle;
            const locationPopupHeader = invntorydata?.locationPopupHeader;
            const locationPopupDescription = invntorydata?.locationPopupDescription ?? '';
            noDataMessage = invntorydata?.noDataMessage ?? noDataMessage;
            otherLocationMessage = invntorydata?.otherLocationMessage ?? otherLocationMessage;
            notAvailableMessage = invntorydata?.notAvailableMessage ?? notAvailableMessage;
            availableMessage = invntorydata?.availableMessage ?? availableMessage;
            enabledOtherLocationMessage = toBoolean(invntorydata?.enabledOtherLocationMessage);
            var locationarr = invntorydata?.locations_arr
            window.locationarr = locationarr;
            locationSelectionType = invntorydata?.locationSelectionType;
            const headerBlock = invntorydata?.headerBlock;
            const headerBlockstyle = invntorydata?.headerBlockstyle;
            const enableGeolocationSearch = invntorydata?.locationFilterSetting?.enableGeolocationSearch ?? 'false';
            const encrypted_google_map_api_key = invntorydata?.locationFilterSetting?.google_api_key ?? '';
            const google_map_api_key = window.multilocation?.decrypt ? window.multilocation.decrypt(encrypted_google_map_api_key) : encrypted_google_map_api_key;
            const distanceIN = invntorydata?.distanceIN;
            const showSettingsHeaderres = invntorydata?.showSettingsHeader ?? '[]';
            const locationDetection = invntorydata?.locationDetection ?? 'false';
            const locationRadius = invntorydata?.locationFilterSetting?.locationRadius ?? 'false';
            const locationRadiusValues = invntorydata?.locationFilterSetting?.locationRadiusValues ?? '0';
            const autoSelectFirstLocation = invntorydata?.autoSelectFirstLocation ?? 'false';
            purchaseOneLocationToast = invntorydata?.purchaseOneLocationToast ?? 'Items you are purchasing are availabe at the location you are choosing. Are you sure you want to switch location.';
            purchaseFromOneLocation = invntorydata?.purchaseFromOneLocation ?? 'false';
            someProductAvailableMessage = invntorydata?.someProductAvailableMessage ?? 'The following items in your cart are not available at Selected location. You can remove unavailable items from your cart and continue...';
            hideOutofStockItems = invntorydata?.hideOutofStockItems ?? 'false';
            pushDownOutofStockItems = invntorydata?.pushDownOutofStockItems ?? 'false';
            enabledSmartCollectionFilter = invntorydata?.enabledSmartCollectionFilter;
            const vercelcountry = invntorydata?.locationFilterSetting?.vercelcountry ?? ''; 
            const vercellatitude = invntorydata?.locationFilterSetting?.vercellatitude ?? '';
            const vercellongitude = invntorydata?.locationFilterSetting?.vercellongitude ?? '';
            const locationBasedonNearest = invntorydata?.locationFilterSetting?.locationBasedonNearest ?? 'false';
            const openNowLabel = invntorydata?.locationSettings?.openNowLabel ?? 'Open Now';
            const ratingsLabel = invntorydata?.locationSettings?.ratingsLabel ?? 'Ratings';
            const closedLabel = invntorydata?.locationSettings?.closedLabel ?? 'Closed';
            const dayNames = invntorydata?.locationSettings?.dayNames;
            const quantityBasedOnLocation = invntorydata?.quantityBasedOnLocation ?? 'false';
            const headerBlockIcon = invntorydata?.headerBlockIcon ?? 'false';
            const headerDisabled = invntorydata?.headerDisabled;
            const geolocationtype = invntorydata?.geolocationtype;
            addressPrepopulation = invntorydata?.addressPrepopulation ?? 'false';
            PickeasyIntegration = invntorydata?.locationFilterSetting?.PickeasyIntegration ?? 'false';
            disablebtnOutofStockItems = invntorydata?.disablebtnOutofStockItems ?? 'false';
            enabledInventoryApi = invntorydata?.locationFilterSetting?.enabledInventoryApi ?? 'false';
            collectionPageProductSelector = invntorydata?.locationFilterSetting?.collectionPageProductSelector ?? '';
            isBundle = invntorydata?.isBundle ?? false;
            updateCollectionInventory({
                collectionPageProductSelector: collectionPageProductSelector,
                enabledInventoryApi: enabledInventoryApi,
                hideOutofStockItems: hideOutofStockItems,
                pushDownOutofStockItems: pushDownOutofStockItems,
                disablebtnOutofStockItems: disablebtnOutofStockItems
            });

            // Apply filter on initial load if we're on a collection page
            setTimeout(() => {
                if (!window.isReloadingForFilter) {
                    applySmartFilterOnNavigation();
                }
            }, 1000);

            if (!window.multilocation) {
                window.multilocation = {};
            }
            
            window.multilocation.setting = {
                quantityBasedOnLocation: quantityBasedOnLocation || 'false'
            };


            // Apply conditional display based on headerDisabled setting
            const locationheaderblock = document.getElementById("locationNamesDropDown");
            if (locationheaderblock) {
                if (headerDisabled === true || headerDisabled === 'true') {
                    locationheaderblock.style.display = 'none';
                } else {
                    locationheaderblock.style.display = 'block';
                }
            }
            // const headerSettingsPriority = JSON.parse(invntorydata?.headerSettingsPriority);
            let headerSettingsPriority = [];
            try {
                if (invntorydata?.headerSettingsPriority) {
                    if (typeof invntorydata.headerSettingsPriority === 'string') {
                        headerSettingsPriority = JSON.parse(invntorydata.headerSettingsPriority);
                    } else if (Array.isArray(invntorydata.headerSettingsPriority)) {
                        headerSettingsPriority = invntorydata.headerSettingsPriority;
                    }
                }
            } catch (error) {
                console.error('Error parsing headerSettingsPriority:', error);
                headerSettingsPriority = ["Show location address", "Show location phone number", "Show location notes", "Show location directions","Show Google Rating and Business Hours"];
            }

            let cust_lat, cust_lng, country;
            if (callapi === false) { await new Promise(resolve => setTimeout(resolve, 200)); }
            ({ cust_lat, cust_lng, country } = await window.multilocation.locationDetection(locationDetection, vercelcountry, vercellatitude, vercellongitude));

            function haversineDistance(lat1, lon1, lat2, lon2) {
                const toRadians = (degrees) => degrees * (Math.PI / 180);
                const R = 6371;
                const dLat = toRadians(lat2 - lat1);
                const dLon = toRadians(lon2 - lon1);
                const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2);
                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                let distance = R * c;
                if (distanceIN === 'false') {
                    distance *= 0.621371;
                }
                return distance;
            }

            function setdistance() {
                locationarr.forEach((loc) => {
                    let locCoords = [0, 0];// = //loc.location_cordinates ? loc.location_cordinates.split(',') : [];
                    locCoords[0] = parseFloat(loc.node.address.latitude);//parseFloat(locCoords[0]);
                    locCoords[1] = parseFloat(loc.node.address.longitude);//parseFloat(locCoords[1]);
                    loc.distance = haversineDistance(parseFloat(cust_lat), parseFloat(cust_lng), locCoords[0], locCoords[1]);
                    if (Number.isNaN(loc.distance)) {
                        loc.distance = '-';
                    }
                });
            }

            window.multilocation.locationBasedonNearest(locationBasedonNearest, cust_lat, cust_lng, locationarr, setdistance);

            if (locationRadius === 'true') {
                setdistance();
                const selectedLocationId = localStorage.getItem("selected_location");
                locationarr = locationarr.filter((loc) => {
                    const radiusMap = JSON.parse(locationRadiusValues || '{}');
                    const radiusForLoc = parseFloat(radiusMap[loc.node.id.split('/').pop()] || '0');
                    const isOutsideRadius = radiusForLoc && loc.distance > radiusForLoc;
                    if (isOutsideRadius && selectedLocationId === loc.node.id.split('/').pop()) {
                        localStorage.removeItem("selected_location");
                    }
                    return !isOutsideRadius;
                });
            }

            let showSettingsHeader;
            try {
                showSettingsHeader = JSON.parse(showSettingsHeaderres);
            } catch (error) {
                showSettingsHeader = []; // Fallback to an empty array
            }

            window.locationPopupData = {
                locationPopup,
                locationPopupstyle,
                locationSelectionType,
                locationPopupHeader,
                locationPopupDescription,
                locationarr,
                purchaseFromOneLocation,
                purchaseOneLocationToast,
                someProductAvailableMessage,
                addressPrepopulation,
                PickeasyIntegration
            };

            if (autoSelectFirstLocation === 'true' && locationarr.length > 0 && !localStorage.getItem("selected_location")) {
                const firstLocationId = locationarr[0].node.id.split('/').pop();
                localStorage.setItem("selected_location", firstLocationId);

                const locationNamesDropDownselect = document.getElementById("locationNamesDropDownselect");
                if (locationNamesDropDownselect) {
                    locationNamesDropDownselect.value = firstLocationId;
                }

                const locationshowonheader = document.getElementById("location-popup-header-id");
                if (locationshowonheader) {
                    locationshowonheader.textContent = locationarr[0].node.name;
                }

                if (window.multiLocationShowLocations) {
                    window.multiLocationShowLocations(firstLocationId);
                }

                const event = new CustomEvent('locationChanged', {
                    detail: { locationId: firstLocationId }
                });
                document.dispatchEvent(event);
            }

            // const locationNamesDropDown = document.getElementById("locationNamesDropDown");
            let locationNamesDropDown;
            const targetElementID = document.getElementById("targetElementID");

            const isEmbedActive = document.querySelector('.is-header-embed-active');
            const isBlockActive = document.querySelector('.is-header-block-active');

            if(isEmbedActive && isBlockActive){
                locationNamesDropDown = document.getElementById("locationNamesDropDown");
            } else if(isEmbedActive){
                const multilocationBlock = document.createElement("div");
                multilocationBlock.id = "multilocationBlock";
                multilocationBlock.classList.add("multilocation-block");
                locationNamesDropDown = document.createElement("div");
                locationNamesDropDown.id = "locationNamesDropDown";
                locationNamesDropDown.classList.add("header-location-dropdown");
                locationNamesDropDown.textContent = "Loading....!";
                const targetedElement = document.querySelector(targetElementID.value);
                const targetPosition = document.getElementById("targetPosition").value || 'append';
                const multilocationIcon = document.getElementById("multi-loca-icon");
                if(multilocationIcon){
                    const EmbedmultilocationIcon = multilocationIcon;
                    multilocationIcon.remove();
                    multilocationBlock.appendChild(EmbedmultilocationIcon);
                }
                multilocationBlock.appendChild(locationNamesDropDown);
                if(targetedElement){
                    if(targetPosition === 'append'){
                        targetedElement.appendChild(multilocationBlock);
                    }
                    if(targetPosition === 'prepend'){
                        targetedElement.prepend(multilocationBlock);
                    }
                    if(targetPosition === 'before'){
                        targetedElement.parentNode.insertBefore(multilocationBlock, targetedElement);
                    }
                    if(targetPosition === 'after'){
                        targetedElement.parentNode.insertBefore(multilocationBlock, targetedElement.nextSibling);
                    }
                }
            } else if(isBlockActive){
                locationNamesDropDown = document.getElementById("locationNamesDropDown");
            }

            const conatinerforall = document.createElement("div");
            const locationNamesDropDownselect = document.createElement("select");
            if (locationNamesDropDown && headerBlock === 'true' && (headerDisabled !== true || headerDisabled !== 'true')) {
                const headerIconRef = document.getElementById("multi-loca-icon");
                if (headerIconRef && headerBlockIcon === 'true') headerIconRef.style.display = 'inline-block';

                locationNamesDropDown.innerHTML = "";
                const locations_arr = locationarr;

                window.multilocaHeaderEvent = async function (selectedLocationId) {
                    await handleLocationChange(selectedLocationId, null, 'dropdown', "false");
                };

                if (headerBlockstyle === 'dropdown') {
                    locationNamesDropDownselect.id = "locationNamesDropDownselect";
                    locationNamesDropDownselect.name = "selected_location";
                    locationNamesDropDownselect.classList.add("location-dropdown");
                    const option = document.createElement("option");
                    option.value = "";
                    option.textContent = "WÄHLE DEINEN STANDORT";
                    locationNamesDropDownselect.appendChild(option);
                    for (const location of locations_arr) {
                        const option = document.createElement("option");
                        option.value = location?.node ? location?.node?.id?.split('/').pop() : location?.id?.split('/').pop();
                        option.textContent = location?.node ? location?.node?.name : location?.name;
                        locationNamesDropDownselect.appendChild(option);
                    }
                    locationNamesDropDown.appendChild(locationNamesDropDownselect);

                    // Sync dropdown selection with radio button selection
                    locationNamesDropDownselect.addEventListener('change', async function () {
                        const selectedLocationId = locationNamesDropDownselect.value;
                        await handleLocationChange(selectedLocationId, null, 'dropdown', purchaseFromOneLocation);
                    });
                }

                if (headerBlockstyle === 'popup') {
                    const locationshowonheader = document.createElement("div");
                    locationshowonheader.classList.add("location-popup-header");
                    locationshowonheader.id = "location-popup-header-id";
                    const savelocationid = localStorage.getItem("selected_location");
                    if (savelocationid == null || savelocationid == undefined || savelocationid == 'undefined' || savelocationid == '') {
                        locationshowonheader.textContent = "WÄHLE DEINEN STANDORT";
                    } else {
                        for (const location of locations_arr) {
                            if (location.node.id.split('/').pop() == savelocationid) {
                                locationshowonheader.textContent = location.node.name;
                            }
                        }
                    }
                    locationNamesDropDown.appendChild(locationshowonheader);
                    locationshowonheader.addEventListener("click", function () {
                        document.dispatchEvent(new CustomEvent("openLocationPopup"));
                    });
                }

                if (headerBlockstyle === 'drawer') {
                    window.multilocation.headerdrawer(locations_arr, display_location_stock, enableGeolocationSearch, showDirectionText, headerSettingsPriority, showSettingsHeader, handleLocationChange, purchaseFromOneLocation, enabledSmartCollectionFilter, openNowLabel, ratingsLabel, closedLabel, dayNames, google_map_api_key, locationNamesDropDown, haversineDistance);
                }

                if (headerBlockstyle === 'searchDropdown') {
                    // For pincode mode, we hide the initial list, awaiting user input
                    const dropdownEl = window.multilocation.createLocationDropdown(locations_arr,handleLocationChange, purchaseFromOneLocation,google_map_api_key,geolocationtype);
                    // If pincode mode, ensure initial list is empty
                    try {
                        if (geolocationtype === 'pincode') {
                            const listEl = dropdownEl.querySelector('.location-list');
                            if (listEl) listEl.innerHTML = '';
                        }
                    } catch (e) {}
                    locationNamesDropDown.appendChild(dropdownEl);
                }

                // After appending the dropdown to the DOM

                // updateCollectionInventory();
                // locationNamesDropDownselect.addEventListener('change', async function () {
                //     const selectedLocationId = locationNamesDropDownselect.value;
                //     await handleLocationChange(selectedLocationId, null, 'dropdown', purchaseFromOneLocation);
                // });
            } else {
                locationNamesDropDown.innerHTML = "";
            }

            const savedLocationId = localStorage.getItem("selected_location");
            if (savedLocationId) {
                locationNamesDropDownselect.value = savedLocationId;
            }
        }

        // Wait for the header location dropdown to be added to the DOM
        waitForElement("#locationNamesDropDownselect", (headerLocationDropdown) => {
            headerLocationDropdown.addEventListener("change", async function () {
                const selectedLocationId = headerLocationDropdown.value;
                await handleLocationChange(selectedLocationId, null, 'dropdown', purchaseFromOneLocation);
            });
        });

        await display_location_stock();

        window.multilocaHeader = display_location_stock;
        document.addEventListener('locationChanged', (e) => {
            const { locationId, locationName } = e.detail || {};
            display_location_stock(locationId, locationName);
        });

        // Header block base locations collection filter
        function attachDropdownListener(locationDropdown) {
            locationDropdown.addEventListener('change', function () {
                let selectedOption = locationDropdown.options[locationDropdown.selectedIndex];
                let selectedLocation = selectedOption ? selectedOption.textContent.trim() : null;
                if (selectedLocation) {
                    let filterCheckboxes = document.querySelectorAll('input[type="checkbox"]');
                    let locationMatched = false;
                    filterCheckboxes.forEach(checkbox => {
                        let label = checkbox.closest('label');
                        let labelText = label ? label.textContent.trim() : "";
                        if (labelText.includes(selectedLocation)) {
                            checkbox.checked = true;
                            locationMatched = true;
                        } else {
                            checkbox.checked = false;
                        }
                    });

                    if (locationMatched) {
                        updateFilterURL(selectedLocation);
                        applyShopifyFilter();
                    } else {
                        console.warn("No matching checkbox found for:", selectedLocation);
                    }
                }
            });
        }

        function isPagedCollection() {
            try {
                const u = new URL(window.location.href);
                const p = u.searchParams.get('page');
                if (!p) return false;
                const n = parseInt(p, 10);
                return !Number.isNaN(n) && n > 0;
            } catch {
                return false;
            }
        }

        // Track if we're currently applying a filter to prevent infinite loops
        let isApplyingFilter = false;
        let lastAppliedFilter = null;

        function updateFilterURL(location, force = false) {
            // Prevent infinite loops
            if (isApplyingFilter) {
                return;
            }

            if (!force) {
                if (typeof isCollectionPage === 'function') {
                    if (isCollectionPage() && isPagedCollection()) return;
                } else {
                    if (isPagedCollection()) return;
                }
            }

            // Check if this filter is already applied
            const currentURL = new URL(window.location.href);
            // const currentFilter = currentURL.searchParams.get('filter.p.tag');
            const currentInventoryFilter = currentURL.searchParams.get('filter.v.m.multilocation_app.inventory_location');
            
            // if (currentFilter === location && currentInventoryFilter === location) {
            if (currentInventoryFilter === location) {
                return;
            }

            isApplyingFilter = true;
            lastAppliedFilter = location;

            let newURL = new URL(window.location.href);
            // newURL.searchParams.set('filter.p.tag', location);
            newURL.searchParams.set('filter.v.m.multilocation_app.inventory_location', location);
            window.location.replace(newURL.toString());
            // Update URL and reload page to apply filter
            // window.history.pushState({}, '', newURL.toString());
            
            // Set a flag to prevent navigation detection from triggering again
            // window.isReloadingForFilter = true;
            
            // Reload page to apply the filter
            // setTimeout(() => {
            //     window.location.reload();
            // }, 100);
            
            // Reset the flag after a delay
            // setTimeout(() => {
            //     isApplyingFilter = false;
            // }, 1000);
        }

        let mlcApplying = false;
        document.addEventListener('locationChanged', (e) => {
            try {
                if (!(enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true')) return;
                if (typeof isCollectionPage === 'function' && !isCollectionPage()) return;

                const nameFromEvent = e?.detail?.locationName;
                const idFromEvent = e?.detail?.locationId;

                // Derive a name if popup didn’t send it (fallback via locationarr)
                let locationName = nameFromEvent || null;
                if (!locationName && typeof locationarr !== 'undefined' && Array.isArray(locationarr)) {
                    const match = locationarr.find(loc => (loc?.node?.id || '').split('/').pop() === idFromEvent);
                    if (match?.node?.name) locationName = match.node.name;
                }
                if (!locationName) return;

                // If the URL already has this filter, skip
                const url = new URL(window.location.href);
                const current = url.searchParams.get('filter.v.m.multilocation_app.inventory_location');
                if (current === locationName) return;

                if (mlcApplying) return;
                mlcApplying = true;

                // Remember for this load so other init code doesn’t re-apply
                sessionStorage.setItem('mlc_last_applied', locationName);

                // One clean navigation (no reload loops)
                updateFilterURL(locationName, true);
            } catch (err) {
                console.warn('Smart filter apply on locationChanged failed:', err);
            } finally {
                // let the stack unwind before allowing another apply
                setTimeout(() => { mlcApplying = false; }, 300);
            }
        });

        function applyShopifyFilter() {
            if (window.Shopify && window.Shopify.theme && window.Shopify.theme.handleFilters) {
                try {
                    window.Shopify.theme.handleFilters();
                } catch (error) {
                    // Don't reload on error, just log it
                }
            } else {
                // Instead of reloading, try to trigger a filter update more gently
                
                // Try to find and trigger filter elements manually
                const filterElements = document.querySelectorAll('[data-filter], .filter, input[type="checkbox"][name*="filter"]');
                if (filterElements.length > 0) {
                    // Don't reload, just let the URL change handle the filtering
                } else {
                    // Only reload as a last resort and only once
                    // if (!window.hasReloadedForFilter) {
                    //     window.hasReloadedForFilter = true;
                    //     setTimeout(() => {
                    //         window.location.reload();
                    //     }, 500);
                    // }
                }
            }
        }
        const observer = new MutationObserver(() => {
            let locationDropdown = document.getElementById('locationNamesDropDownselect');
            if (locationDropdown) {
                observer.disconnect();
                if (enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true') {
                    attachDropdownListener(locationDropdown);
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });

        document.querySelectorAll('variant-radios').forEach(variantRadio => {
            const variantDataScript = variantRadio.querySelector('script[type="application/json"]');
            if (!variantDataScript) return;

            const variantData = JSON.parse(variantDataScript.textContent);
            const radioInputs = variantRadio.querySelectorAll('input[type="radio"]');

            radioInputs.forEach(input => {
                input.addEventListener('change', () => {
                    const selectedOptionValue = input.value;
                    const matchingVariant = variantData.find(variant => variant.title === selectedOptionValue);

                    if (!matchingVariant) {
                        console.warn("No matching variant found for selected option:", selectedOptionValue);
                        return;
                    }

                    const selectedVariantId = matchingVariant.id;
                    const productId = variantRadio.getAttribute('data-product');

                    const card = document.querySelector(`.multilocation_product-card[data-product-id="${productId}"]`);

                    if (!card) {
                        console.warn(`No product card found for product ID: ${productId}`);
                        return;
                    }

                    const variantWrapper = card.querySelector('.multi_variant_id');
                    if (variantWrapper) {
                        variantWrapper.setAttribute('data-variant-id', selectedVariantId);
                        updateInventoryForCard(card, selectedVariantId);
                    }
                });
            });
        });

        function updateInventoryForCard(card, variantId) {
            const selectedLocationId = localStorage.getItem("selected_location");
            let inventoryStatus = card.querySelector('.multiloc_inventory-status');
            let inventoryContainer = card.querySelector('.multiloc_inventory-container');
            if(!inventoryStatus || !inventoryContainer){
                inventoryStatus = document.createElement('div');
                inventoryStatus.classList.add('multiloc_inventory-status');
                const cartbutton = card.querySelector('form button[type="submit"], form input[type="submit"]');
                cartbutton?.parentNode?.insertBefore(inventoryStatus, cartbutton);
                inventoryContainer = document.createElement('div');
                inventoryContainer.classList.add('multiloc_inventory-container');
                cartbutton?.parentNode?.insertBefore(inventoryContainer, cartbutton.nextSibling);
            }

            if (!variantId || !window.inventoryData || !window.inventoryData.inventoryMap[variantId]) {
                inventoryStatus.textContent = "No data for selected variant";
                inventoryStatus.style.color = "gray";
                return;
            }

            const variantData = window.inventoryData.inventoryMap[variantId];
            inventoryContainer.innerHTML = '';
            if(enabledFullfillment == 'true'){
              window.multilocation.attachEventListeners(addToCartSelector, variantId, quantityBasedOnLocationoutside, variantData.inventoryLevels, isBundle=false, bundleComponentVariantIds );
            }

            if (!variantData.inventoryLevels || variantData.inventoryLevels.length === 0) {
                inventoryStatus.textContent = "No stock data available";
                inventoryStatus.style.color = "gray";
                return;
            }

            const selectedLocationInventory = variantData.inventoryLevels.filter(
                level => String(level.location_id) === String(selectedLocationId)
            );

console.log(selectedLocationInventory);
            const allLocationsInventory = variantData.inventoryLevels.filter(
                level => level.available_quantity > 0
            );
               if (!selectedLocationId) {
                console.log(card);
                
                const parentCard = card.closest('.product-item');
                const hiddenVariantInput = parentCard ? parentCard.querySelector(`input[type="hidden"][name="id"]`) : null;
                console.log("hiddenVariantInput", hiddenVariantInput);
                if (hiddenVariantInput) {
                    const addButton = hiddenVariantInput.parentNode.querySelector('button[name="add"]');
                    if (addButton) {
                        addButton.disabled = true;
                        addButton.classList.add('disabled');
                    }
                }
                inventoryStatus.textContent = "Kein Standort ausgewählt";
                inventoryStatus.style.color = "red";
                inventoryContainer.innerHTML = '';
                return;
            } else {
                const parentCard = card.closest('.product-item');
                const hiddenVariantInput = parentCard ? parentCard.querySelector(`input[type="hidden"][name="id"]`) : null;
                console.log("hiddenVariantInput", hiddenVariantInput);
                if (hiddenVariantInput) {
                    const addButton = hiddenVariantInput.parentNode.querySelector('button[name="add"]');
                    if (addButton) {
                        if(selectedLocationInventory.length === 0 || selectedLocationInventory[0].available_quantity <= 0){} else {
                            addButton.disabled = false;
                            addButton.classList.remove('disabled');
                        }
                    }
                }   
            }

            // Clear the inventory container first
            inventoryContainer.innerHTML = '';

            // First check if the selected location has inventory
            const hasStockAtSelectedLocation = selectedLocationInventory.some(level => level.available_quantity > 0);

            // Then check if other locations have inventory
            const otherLocationsWithStock = allLocationsInventory.filter(
                level => String(level.location_id) !== String(selectedLocationId) && level.available_quantity > 0
            );

            // Ensure enabledOtherLocationMessage is a boolean
            const isOtherLocationMsgEnabled = toBoolean(enabledOtherLocationMessage);

        // if (hasStockAtSelectedLocation) {

        //     const locationName =
        //         (selectedLocationInventory[0] &&
        //             (selectedLocationInventory[0].location_name ||
        //                 selectedLocationInventory[0].location?.name ||
        //                 selectedLocationInventory[0].name)) ||
        //         "";

        //     console.log("locationName", locationName);

        //     let statusMsg = String(availableMessage || "✔ Available");

        //     // Insert location name
        //     // if (locationName) {
        //     //     if (statusMsg.includes("{{location_name}}")) {
        //     //         statusMsg = statusMsg.replace("{{location_name}}", locationName);
        //     //     } else {
        //     //         statusMsg = statusMsg + " " + locationName;
        //     //     }
        //     // }
        //      if (locationName) {
        //         const availStockLocation = `<span style="color:#3abf62;font-size:15px;">${locationName}</span>`;

        //         if (statusMsg.includes("{{location_name}}")) {
        //             statusMsg = statusMsg.replace("{{location_name}}", availStockLocation);
        //         } else {
        //             statusMsg = statusMsg + " " + availStockLocation;
        //         }
        //     }

        //     inventoryStatus.innerHTML = statusMsg;

        // } else if (!hasStockAtSelectedLocation && otherLocationsWithStock.length > 0 && isOtherLocationMsgEnabled) {

        //     const otherLoc = otherLocationsWithStock[0];

        //     const otherLocationName =
        //         otherLoc.location_name ||
        //         otherLoc.location?.name ||
        //         otherLoc.name ||
        //         "";

        //     let otherMsg = String(otherLocationMessage || "");
        //     // Insert location name
            
        //   if (otherLocationName) {
        //         const availOtherLocation = `<span style="color:#FFA500;font-size:15px;">${otherLocationName}</span>`;

        //         if (otherMsg.includes("{{location_name}}")) {
        //             otherMsg = otherMsg.replace("{{location_name}}", availOtherLocation);
        //         } else {
        //             otherMsg = otherMsg + " " + availOtherLocation;
        //         }
        //     }
        //     inventoryStatus.innerHTML = otherMsg;
        //     return;

        // } else {
            
        //      let outMsg = String(notAvailableMessage || "Out of stock");

        //             const locationName =
        //                 (selectedLocationInventory[0] &&
        //                     (selectedLocationInventory[0].location_name ||
        //                         selectedLocationInventory[0].location?.name ||
        //                         selectedLocationInventory[0].name)) ||
        //                 "";

        //             if (locationName) {
        //                 const outOfStockLocation = `<span style="color:#ff5858;font-size:15px;">${locationName}</span>`;

        //                 if (outMsg.includes("{{location_name}}")) {
        //                     outMsg = outMsg.replace("{{location_name}}", outOfStockLocation);
        //                 } else {
        //                     outMsg = outMsg + " " + outOfStockLocation;
        //                 }
        //             }

        //             inventoryStatus.innerHTML = outMsg;
        //         }
                    if (hasStockAtSelectedLocation) {

                const locationName =
                    (selectedLocationInventory[0] &&
                        (selectedLocationInventory[0].location_name ||
                            selectedLocationInventory[0].location?.name ||
                            selectedLocationInventory[0].name)) ||
                    "";

                console.log("locationName", locationName);

                let statusMsg = String(availableMessage || "✔ Available");

                // Insert location name with green color
                if (locationName) {
                    const availStockLocation = `<span style="color:#3abf62;font-size:15px;">${locationName}</span>`;

                    if (statusMsg.includes("{{location_name}}")) {
                        statusMsg = statusMsg.replace("{{location_name}}", availStockLocation);
                    } else {
                        statusMsg = statusMsg + " " + availStockLocation;
                    }
                }

                inventoryStatus.innerHTML = statusMsg;

            } else if (
                !hasStockAtSelectedLocation &&
                otherLocationsWithStock.length > 0 &&
                isOtherLocationMsgEnabled
            ) {

                const otherLoc = otherLocationsWithStock[0];

                const otherLocationName =
                    otherLoc.location_name ||
                    otherLoc.location?.name ||
                    otherLoc.name ||
                    "";

                let otherMsg = String(otherLocationMessage || "");
                if (otherLocationName) {
                    const availOtherLocation = `<span style="color:#FFA500;font-size:15px;">${otherLocationName}</span>`;

                    if (otherMsg.includes("{{location_name}}")) {
                        otherMsg = otherMsg.replace("{{location_name}}", availOtherLocation);
                    } else {
                        otherMsg = otherMsg + " " + availOtherLocation;
                    }
                }
                const selectedLocationName =
                    (selectedLocationInventory[0] &&
                        (selectedLocationInventory[0].location_name ||
                            selectedLocationInventory[0].location?.name ||
                            selectedLocationInventory[0].name)) ||
                    "";

                let outMsg = "";

                if (selectedLocationName) {
                    outMsg = `<span style="color:#FFA500;font-size:15px;">Nicht verfügbar in ${selectedLocationName}</span>`;
                }

                inventoryStatus.innerHTML = `${outMsg}<br>${otherMsg}`;
                return;

            } else {

                let outMsg = String(notAvailableMessage || "Out of stock");

                const locationName =
                    (selectedLocationInventory[0] &&
                        (selectedLocationInventory[0].location_name ||
                            selectedLocationInventory[0].location?.name ||
                            selectedLocationInventory[0].name)) ||
                    "";

                if (locationName) {
                    const outOfStockLocation = '';//`<span style="color:#ff5858;font-size:15px;">${locationName}</span>`;

                    if (outMsg.includes("{{location_name}}")) {
                        outMsg = outMsg.replace("{{location_name}}", outOfStockLocation);
                    } else {
                        outMsg = outMsg + " " + outOfStockLocation;
                    }
                }

                inventoryStatus.innerHTML = outMsg;
            }



        }

        // updateCollectionInventory function is now defined earlier in the file, before it's called


        // await updateCollectionInventory();

        document.addEventListener("updateCollectionInventory", function () {
            const selectedLocationId = localStorage.getItem("selected_location");
            if (selectedLocationId) {
                updateCollectionInventory({
                    collectionPageProductSelector: collectionPageProductSelector,
                    enabledInventoryApi: enabledInventoryApi,
                    hideOutofStockItems: hideOutofStockItems,
                    pushDownOutofStockItems: pushDownOutofStockItems,
                    disablebtnOutofStockItems: disablebtnOutofStockItems
                });
                if (enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true') {
                    // const locationshowonheader = document.createElement("div");
                    // locationshowonheader.classList.add("location-popup-header");
                    // locationshowonheader.id = "location-popup-header-id";

                    const locationshowonheader = document.getElementById("location-popup-header-id");
                    if (locationshowonheader && locationshowonheader.textContent && locationshowonheader.textContent !== "WÄHLE DEINEN STANDORT") {
                        const locationname = locationshowonheader.textContent;
                        updateFilterURL(locationname);
                        // Don't call applyShopifyFilter() here as updateFilterURL() already calls it
                    }
                }
            }
        });

        function getStoredCheckoutAddress() {
            try {
                // Primary keys for structured address (include our custom key)
                const raw = localStorage.getItem('selected_location_address_object')
                    || localStorage.getItem('ml_selected_address')
                    || localStorage.getItem('selected_location_address')
                    || localStorage.getItem('customerAddress');
                if (raw) {
                    let parsed = null;
                    try {
                        parsed = JSON.parse(raw);
                    } catch (e1) {
                        // If already an object stringified twice or contains JSON substring, try to recover
                        try {
                            // Example: '"{\"area\":\"Pune\"...}"' -> parse twice
                            const once = JSON.parse(raw);
                            if (typeof once === 'string') {
                                parsed = JSON.parse(once);
                            }
                        } catch (e2) {
                            // Try to extract JSON between first { and last }
                            const start = raw.indexOf('{');
                            const end = raw.lastIndexOf('}');
                            if (start !== -1 && end !== -1 && end > start) {
                                try { parsed = JSON.parse(raw.slice(start, end + 1)); } catch (e3) {}
                            }
                        }
                    }
                    if (parsed && typeof parsed === 'object') {
                        return parsed;
                    }
                }
                // Fallback to older keys: text + pincode
                const text = localStorage.getItem('selected_location_text') || '';
                const pincode = localStorage.getItem('selected_location_pincode') || '';
                if (text || pincode) {
                    return {
                        area: text || '',
                        city: '',
                        state: '',
                        pincode: pincode || '',
                        country: ''
                    };
                }
            } catch (e) {}
            return null;
        }

        function buildCheckoutURLFromAddress(addressObj) {
            let baseURL = '/checkout';
            if (!addressObj) return baseURL;

            console.log(addressObj);

            const params = new URLSearchParams();
            const area = addressObj.area || addressObj.address || addressObj.address1 || '';
            const city = addressObj.city || '';
            const state = addressObj.state || addressObj.province || '';
            const zip = addressObj.pincode || addressObj.zipcode || addressObj.postalCode || '';
            const country = addressObj.country || 'India';

            if (area) {
                params.append('checkout[shipping_address][address1]', area);
            }
            if (addressObj.address2) {
                params.append('checkout[shipping_address][address2]', addressObj.address2);
            }
            if (city) {
                params.append('checkout[shipping_address][city]', city);
            }
            if (state) {
                params.append('checkout[shipping_address][province]', state);
            }
            if (zip) {
                params.append('checkout[shipping_address][zip]', zip);
            }
            if (country) {
                params.append('checkout[shipping_address][country]', country);
            }
                params.append('method',"checkout");

            const qs = params.toString();
            if (qs) {
                baseURL += '?' + qs;
            }
            return baseURL;
        }

        function attachCheckoutPrepopulation() {
            const navigateWithAddress = () => {
                const address = getStoredCheckoutAddress();
                const url = address ? buildCheckoutURLFromAddress(address) : '/checkout';
                window.location.href = url;
            };

            // Anchor-based checkout links
            const checkoutLinkSelectors = [
                'a[href^="/checkout"]',
                'a[href*="/checkout?"]'
            ];
            checkoutLinkSelectors.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => {
                    el.addEventListener('click', function (e) {
                        e.preventDefault();
                        navigateWithAddress();
                    });
                });
            });

            // Button-based checkout actions
            const checkoutButtonSelectors = [
                'button[name="checkout"]',
                'input[name="checkout"]',
                '[data-cart-checkout]'
            ];
            checkoutButtonSelectors.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => {
                    el.addEventListener('click', function (e) {
                        e.preventDefault();
                        navigateWithAddress();
                    });
                });
            });

            // Form submission on cart
            document.querySelectorAll('form[action="/cart"]').forEach(form => {
                form.addEventListener('submit', function (e) {
                    // Only intercept if submitting to checkout
                    const activeEl = document.activeElement;
                    const isCheckoutSubmit = activeEl && (activeEl.getAttribute('name') === 'checkout' || activeEl.matches('button[name="checkout"], input[name="checkout"]'));
                    if (isCheckoutSubmit) {
                        e.preventDefault();
                        navigateWithAddress();
                    }
                });
            });
        }
        if (addressPrepopulation === true || addressPrepopulation === 'true') {
        // Initialize after a short delay to allow cart/checkout buttons to render
            setTimeout(attachCheckoutPrepopulation, 500);
        }

        // Simple navigation detection for smart filter application
        function isCollectionPage() {
            const currentPath = window.location.pathname || '';
            const isCollection = currentPath.includes('/collections/') || currentPath.includes('/collection/');
            const isProduct = currentPath.includes('/products/') || currentPath.includes('/product/');

            // If the path contains both collection and product segments, treat it as NOT a collection page
            if (isCollection && isProduct) {
                return false;
            }

            return isCollection;
        }

        function applySmartFilterOnNavigation() {
            if (enabledSmartCollectionFilter === true || enabledSmartCollectionFilter === 'true') {
                if (!isCollectionPage()) return;
                
                // New: don't auto-add/modify on ?page>1
                if (isPagedCollection()) return;
                
                const selectedLocationId = localStorage.getItem("selected_location");
                if (selectedLocationId && isCollectionPage()) {
                    const locationshowonheader = document.getElementById("location-popup-header-id");
                    const locationDropdown = document.getElementById("locationNamesDropDownselect");
                    
                    let locationname = null;
                    
                    if (locationshowonheader && locationshowonheader.textContent && locationshowonheader.textContent !== "WÄHLE DEINEN STANDORT") {
                        locationname = locationshowonheader.textContent;
                    } else if (locationDropdown && locationDropdown.value) {
                        const selectedOption = locationDropdown.options[locationDropdown.selectedIndex];
                        locationname = selectedOption ? selectedOption.textContent.trim() : null;
                    }
                    
                    if (locationname) {
                        updateFilterURL(locationname);
                    }
                }
            }
        }


                // Function to clear cache (useful when navigating to different pages)
        function clearInventoryCache() {
            inventoryDataCache = null;
            inventoryDataPromise = null;
            window.inventoryData = null;
        }

        async function fetchInventoryData(productId) {
            // If we already have a promise in progress, return it
            if (inventoryDataPromise) {
                return inventoryDataPromise;
            }

            // If we have cached data for the same product IDs, return it
            if (inventoryDataCache && inventoryDataCache.productId === productId) {
                return inventoryDataCache.data;
            }

            // Create a new promise for fetching data
            inventoryDataPromise = (async () => {
                try {
                    const response = await fetch(`https://multiloca.info/api/get-collection-product-inventory?shopdomain=${encodeURIComponent(shopdomain)}&productId=${productId}`);

                    if (!response.ok) {
                        console.error(`Failed to fetch inventory data. Status: ${response.status}`);
                        return null;
                    }

                    const data = await response.json();

                    if (!data || typeof data !== 'object') {
                        console.error("Invalid data structure received from the API.");
                        return null;
                    }

                    // Cache the data
                    inventoryDataCache = { productId, data };
                    window.inventoryData = data;

                    return data;
                } catch (error) {
                    console.error("Error fetching inventory data:", error);
                    return null;
                } finally {
                    // Clear the promise after completion
                    inventoryDataPromise = null;
                }
            })();

            return inventoryDataPromise;
        }

        // Expose cache management functions globally
        window.clearInventoryCache = clearInventoryCache;
        window.fetchInventoryData = fetchInventoryData;

        // Global function to update collection inventory
        window.multilocation = window.multilocation || {};
        async function updateCollectionInventory(settings) {
            const {
                collectionPageProductSelector: customSelectorParam,
                enabledInventoryApi: enabledInventoryApiParam,
                hideOutofStockItems: hideOutofStockItemsParam,
                pushDownOutofStockItems: pushDownOutofStockItemsParam,
                disablebtnOutofStockItems: disablebtnOutofStockItemsParam
            } = settings || {};

            const selectedLocationId = localStorage.getItem("selected_location");
            setTimeout(async () => {
                const customSelector = (customSelectorParam || '').trim();
                const defaultSelector = '.multilocation_product-card[data-product-id]';
                let productCards;
                try {
                    if (enabledInventoryApiParam === 'true' && customSelector) {
                        productCards = document.querySelectorAll(customSelector);
                    } else {
                        productCards = document.querySelectorAll(defaultSelector);
                    }
                } catch (err) {
                    productCards = document.querySelectorAll(defaultSelector);
                }

                const productId = Array.from(productCards)
                    .map((card)=>{
                        const formElement = card.querySelector('form');
                        if (formElement) {
                            const id = formElement.querySelector('input[name="product-id"]');
                            if(id){
                                return id.value;
                            }
                        } else {
                            if(enabledInventoryApiParam === 'true'){
                                const multilocationCard = card.querySelector('.multilocation_product-card');
                                return multilocationCard ? multilocationCard.getAttribute('data-product-id') : null;
                            } else {
                                return card.getAttribute('data-product-id');
                            }
                        }
                    }).filter(Boolean)
                    .join(",");

                if (!productId) {
                    return;
                }

                try {
                    // Use the cached fetch function
                    const data = await fetchInventoryData(productId);

                    if (!data) {
                        return;
                    }

                    productCards.forEach(card => {
                        const variantWrapper = card.querySelector('.multi_variant_id');
                        const variantId = variantWrapper?.getAttribute('data-variant-id') || card.querySelector('form input[name="id"]')?.value;
                        if (!variantId || !data.inventoryMap[variantId]) {
                            console.warn(`No inventory data for variantId: ${variantId}`);
                            return;
                        }

                        updateInventoryForCard(card, variantId);
                    });

                    document.querySelectorAll(".owl-item").forEach((variantWrapper) => {
                        disbaledaddtocartbtn(variantWrapper, data, selectedLocationId);
                    });

                    document.querySelectorAll("li.grid__item, div.grid__item, .multi_variant_id").forEach((variantWrapper) => {
                        setTimeout(() => {
                            if (hideOutofStockItemsParam === true || hideOutofStockItemsParam === 'true') {
                                disbaledaddtocartbtngeneric(variantWrapper, data, selectedLocationId);
                            } else if (pushDownOutofStockItemsParam === true || pushDownOutofStockItemsParam === 'true') {
                                sortProductsByLocationInventory();
                            } else if (disablebtnOutofStockItemsParam === true || disablebtnOutofStockItemsParam === 'true') {
                                disbaledaddtocartbtnofoutofstock(variantWrapper, data, selectedLocationId);
                            }
                        }, 100);
                    });
                } catch (error) {
                    console.error("Error fetching inventory data:", error);
                }
            }, 500);
        }
        window.multilocation.updateCollectionInventory = updateCollectionInventory;

        // Global functions for handling out of stock items
        function getInventoryForLocation(variantId, locationId) {
            const inventoryMap = window.inventoryData?.inventoryMap || {};
            const variantEntry = inventoryMap[variantId];
          
            if (!variantEntry || !variantEntry.inventoryLevels) return -1;
          
            const level = variantEntry.inventoryLevels.find(
              (lvl) => lvl.location_id === locationId
            );
            return level ? level.available_quantity : -1;
        }

        function disbaledaddtocartbtngeneric(variantWrapper, data, selectedLocationId) {
            const variantId = variantWrapper.getAttribute("data-variant-id") || variantWrapper.getAttribute("data-product-id");
            if (!variantId) return;
            
            const inventoryMap = data?.inventoryMap?.[variantId]?.inventoryLevels || [];
            const inventoryPolicy = data?.inventoryMap?.[variantId]?.inventoryPolicy || "deny";
            if(inventoryPolicy === "CONTINUE") {
                return;
            }
            const locationInventory = inventoryMap.find(location => location.location_id === selectedLocationId);
            const parentLi = variantWrapper.closest('li');
            if(parentLi){
                if (locationInventory?.available_quantity <= 0) {   
                    parentLi.style.display = "none";
                }
                else{
                    parentLi.style.display = "block";
                }
            } else {
                const parentDiv = variantWrapper.closest('.shop__grid-item');
                if(parentDiv){
                    if (locationInventory?.available_quantity <= 0) {
                        parentDiv.style.display = "none";
                    } else {
                        parentDiv.style.display = "block";
                    }
                }
            }
        }

        function disbaledaddtocartbtnofoutofstock(variantWrapper, data, selectedLocationId) {
            const variantId = variantWrapper.getAttribute("data-variant-id") || variantWrapper.getAttribute("data-product-id");
            if (!variantId) return;
            const inventoryMap = data?.inventoryMap?.[variantId]?.inventoryLevels || [];
            const inventoryPolicy = data?.inventoryMap?.[variantId]?.inventoryPolicy || "deny";
            if(inventoryPolicy === "CONTINUE") {
                return;
            }
            const locationInventory = inventoryMap.find(location => location.location_id === selectedLocationId);
            const parentLi = variantWrapper.closest('li');
            if(parentLi){
                if (locationInventory?.available_quantity <= 0) {
                    const addtocartbtn = parentLi.querySelector('button[name="add"]');
                    if(addtocartbtn){
                        addtocartbtn.disabled = true;
                        addtocartbtn.classList.add("disabled");
                    }
                }
                else{
                    const addtocartbtn = parentLi.querySelector('button[name="add"]');
                    if(addtocartbtn){
                        addtocartbtn.disabled = false;
                        addtocartbtn.classList.remove("disabled");
                    }
                }
            } else {
                const parentDiv = variantWrapper.closest('.shop__grid-item');
                if(parentDiv){
                    if (locationInventory?.available_quantity <= 0) {
                        const addtocartbtn = parentDiv.querySelector('button[name="add"]');
                        if(addtocartbtn){
                            addtocartbtn.disabled = true;
                            addtocartbtn.classList.add("disabled");
                            addtocartbtn.textContent = "Sold out";
                        }
                    } else {
                        const addtocartbtn = parentDiv.querySelector('button[name="add"]');
                        if(addtocartbtn){
                            addtocartbtn.disabled = false;
                            addtocartbtn.classList.remove("disabled");
                            addtocartbtn.textContent = "Add to cart";
                        }
                    }
                }
            }
        }

        function disbaledaddtocartbtn(variantWrapper, data, selectedLocationId) {
            const variantId = variantWrapper.getAttribute("data-variant-id");
            const inventoryMap = data?.inventoryMap[variantId]?.inventoryLevels || [];
            const locationInventory = inventoryMap.find(location => location.location_id === selectedLocationId);
            if (locationInventory && locationInventory.available_quantity <= 0) {
                variantWrapper.remove();
            }
        }

        function sortProductsByLocationInventory() {
            const selected_location = localStorage.getItem("selected_location");
            if (!selected_location) {
              console.error("[Inventory Sort] No selected_location found");
              return;
            }
        
            const variantNodes = Array.from(
              document.querySelectorAll(".multi_variant_id[data-variant-id]"),
            );
            if (variantNodes.length === 0) {
              console.error(
                "[Inventory Sort] No .multi_variant_id with data-variant-id found",
              );
              return;
            }
            const variantDataMap = new Map();
        
            for (const variantEl of variantNodes) {
              const variantId = variantEl.dataset.variantId;
              if (!variantId) continue;
        
              const inventoryQty = getInventoryForLocation(
                variantId,
                selected_location,
              );
        
              const parentItem = variantEl.closest(
                "li.grid__item, div.grid__item, .product-item-sort",
              );
              if (!parentItem) {
                console.warn(
                  `[Inventory Sort] No matching parent container for variantId ${variantId}`,
                );
                continue;
              }
        
              variantDataMap.set(parentItem, inventoryQty);
            }
        
            const sortedItems = [...variantDataMap.entries()]
              .sort(([, a], [, b]) => (b || -1) - (a || -1))
              .map(([item]) => item);
        
            if (sortedItems.length > 0) {
              const parentContainer = sortedItems[0].parentNode;
              sortedItems.forEach((item) => parentContainer.appendChild(item));
              console.log(
                "[Inventory Sort] Products re-sorted by inventory at location:",
                selected_location,
              );
            }
        }

        // // Listen for navigation events
        // let currentUrl = window.location.href;
        // const urlObserver = new MutationObserver(() => {
        //     if (window.location.href !== currentUrl) {
        //         currentUrl = window.location.href;
        //         if (!window.isReloadingForFilter) {
        //             setTimeout(() => {
        //                 applySmartFilterOnNavigation();
        //             }, 1000);
        //         }
        //     }
        // });

        // // Listen for popstate (back/forward navigation)
        // window.addEventListener('popstate', () => {
        //     if (!window.isReloadingForFilter) {
        //         setTimeout(() => {
        //             applySmartFilterOnNavigation();
        //         }, 1000);
        //     }
        // });

        // // Apply on initial load
        // setTimeout(() => {
        //     if (!window.isReloadingForFilter) {
        //         applySmartFilterOnNavigation();
        //     }
        // }, 2000);

        // // Start observing
        // urlObserver.observe(document.body, { childList: true, subtree: true });

        // this function is for www.feuerwerk-outlet.de this shop only
        function MultilocaCatlogType() {
            const buttons = document.querySelectorAll(".shopwahl-popup-button");
            if (buttons.length > 0) {
                const currentType = localStorage.getItem("multiloca_custom_key");
                buttons.forEach(btn => {
                    btn.addEventListener("click", function() {
                        console.log("Button clicked:");
                        const type = this.dataset.type || '';
                        localStorage.setItem("multiloca_custom_key", type);
                        localStorage.removeItem("selected_location");
                    });
                });
            }

            const container = document.getElementById('topbar');
            if(container){
                container.querySelectorAll('.ct-btn').forEach(btn => {
                        btn.addEventListener('click', function() {
                            console.log("Button clicked:");
                            const choice = this.getAttribute('data-choice') || '';
                            localStorage.setItem("multiloca_custom_key", choice);
                            localStorage.removeItem("selected_location");
                        });
                    }
                );
            }
        }
        const shopName = window.Shopify?.shop || '';
        if(shopName === 'feuerwerks.myshopify.com'){
            MultilocaCatlogType();
        }

        window.refreshLocation = async function(locationId) {
            const selectedLocationId = locationId;
            // Use the new handleLocationChange function
            const changeSuccessful = await handleLocationChange(selectedLocationId, window.locationarr, 'drawer', 'true');
            // const changeSuccessful = await executeLocationChange(selectedLocationId, null);
        }


    }
    setInterval(() => {
    const elements = document.querySelectorAll(".location-card-drawer-list-view-address");
    elements.forEach(elem => {
      if (!elem.dataset.modified) {
        const lines = elem.innerHTML.split("<br>");
        // console.log("lines",lines.length);
        if (lines.length == 4) {
          const line1 = lines[0] ? lines[0].trim() : "";
          const line2 = lines[1] ? lines[1].trim() : "";
          elem.textContent = `${line1}`;
          elem.dataset.modified = "true";
        } else if (lines.length == 5) {
          const line1 = lines[0] ? lines[0].trim() : "";
          const line2 = lines[1] ? lines[1].trim() : "";
          elem.textContent = `${line1} ${line2}`;
          elem.dataset.modified = "true";
        }
      }
    });
  }, 500);
});